export enum AdvisorType {
    PartTime = 1,
    FullTime = 2
}
